// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import KeyGoalsArea from './KeyGoalsArea';
// css
import '../../../styles/containers/analytics/KeyGoals.scss';


class KeyGoals extends Component {
  // Calculates the number of columns in the each row of a 3 column
  // inline block grid.
  // Each full row will have a value of 3, otherwise it will be 2 or 1
  calculateAreaColumnCount(index, size) {
    const lastRowColumns = size % 3;
    const spacing = index < size - lastRowColumns ? 3 : lastRowColumns;

    return spacing;
  }

  renderAreas() {
    const areas = this.props.groupedKeyGoalsWithAnswers;
    return areas.map((area, index) => (
      <KeyGoalsArea
        spacing={this.calculateAreaColumnCount(index, areas.length)}
        active={area.active}
        key={area.id}
        title={area.title}
        goals={area.goals}
      />
    ));
  }

  render() {
    const { keyGoalsCount } = this.props;

    return (
      <div className='analytics__key-goals'>
        <div className='analytics__key-goals-area-pptx' id={this.props.pptxTarget}>
          <h2>
            <span>{keyGoalsCount} Key Goals</span>
          </h2>
          <div className='analytics__key-goals-areas-pptx'>
            {this.renderAreas()}
          </div>
        </div>
      </div>
    );
  }
}

KeyGoals.propTypes = {
  groupedKeyGoalsWithAnswers: PropTypes.array.isRequired,
  pptxTarget: PropTypes.string,
  keyGoalsCount: PropTypes.number.isRequired
};

export default KeyGoals;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/KeyGoals.js